"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFilter = void 0;
var _isEqual = _interopRequireDefault(require("es-toolkit/compat/isEqual"));
var _react = require("react");
var _bannerProductListingContext = require("../../../contexts/bannerProductListingContext");
var _utils = require("../../../utils");
var _useDelayedLoading = require("../../../utils/useDelayedLoading");
var _useGetFacets = require("./useGetFacets");
// Just for encapsulation of logic for filter component on PLP
const useFilter = (param)=>{
    let { initialValue, loadData, appliedFacets, setAppliedFacets } = param;
    const { getFacets } = (0, _bannerProductListingContext.useBannerProductListingContext)();
    // this is value for filter component
    const [facets, setFacets] = (0, _react.useState)();
    const [isInitialLoaded, setIsInitialLoaded] = (0, _react.useState)(false);
    const { data, isValidating, isError } = (0, _useGetFacets.useGetFacets)({
        facets: (0, _utils.mapFacetFilterValuesToFacetQuery)(facets),
        getFacets
    });
    const { isLoading } = (0, _useDelayedLoading.useDelayedLoading)({
        loading: isValidating
    });
    /**
   * Used for displaying selected facets in filter container
   * It is different than appliedFacets, because appliedFacets can contain facets that are not selected
   */ const selectedFacets = (0, _react.useMemo)(()=>appliedFacets.flatMap((facet)=>facet.items.filter((item)=>item.selected).map((item)=>({
                    ...item,
                    category: facet.key
                }))), [
        appliedFacets
    ]);
    const onFilterChange = (0, _react.useCallback)(async (values)=>{
        setIsInitialLoaded(true);
        setFacets(values);
    }, []);
    (0, _react.useEffect)(()=>{
        if (!isInitialLoaded && (0, _utils.mapFacetFilterValuesToFacetQuery)(appliedFacets).length > 0 && !(0, _isEqual.default)((0, _utils.mapFacetFilterValuesToFacetQuery)(data), (0, _utils.mapFacetFilterValuesToFacetQuery)(appliedFacets))) {
            void onFilterChange(appliedFacets);
        }
    }, [
        appliedFacets,
        data,
        isInitialLoaded,
        onFilterChange
    ]);
    const onFilterApply = (0, _react.useCallback)(async (value)=>{
        await setAppliedFacets(value);
        loadData();
    }, [
        loadData,
        setAppliedFacets
    ]);
    const onClear = (0, _react.useCallback)(async ()=>{
        const updatedValue = appliedFacets.map((facet)=>({
                ...facet,
                items: facet.items.map((item)=>({
                        ...item,
                        selected: false
                    }))
            }));
        await setAppliedFacets(updatedValue);
        await onFilterChange(updatedValue);
        loadData();
    }, [
        onFilterChange,
        loadData,
        appliedFacets,
        setAppliedFacets
    ]);
    const onFilterClose = (0, _react.useCallback)(async ()=>{
        /**
     * When user clicks on close button, we need to reset filter facets to currently applied facets.
     * This is because user can change filter facets, but not apply them.
     */ if (!(0, _isEqual.default)(data, appliedFacets)) {
            await onFilterChange(appliedFacets);
        }
    }, [
        appliedFacets,
        data,
        onFilterChange
    ]);
    const onFacetFilterClear = (0, _react.useCallback)(async (key, category)=>{
        const updatedValue = appliedFacets.map((facet)=>facet.key === category ? {
                ...facet,
                items: facet.items.map((item)=>item.value === key ? {
                        ...item,
                        selected: false
                    } : item)
            } : facet);
        await setAppliedFacets(updatedValue);
        await onFilterChange(updatedValue);
        await onFilterApply(updatedValue);
    }, [
        appliedFacets,
        onFilterApply,
        onFilterChange,
        setAppliedFacets
    ]);
    var _ref;
    return {
        onFilterApply,
        onFilterChange,
        onClear,
        selectedFacets,
        onFilterClose,
        onFacetFilterClear,
        filterValue: (_ref = isLoading || isError ? facets : data) !== null && _ref !== void 0 ? _ref : initialValue,
        appliedFacets,
        setAppliedFacets,
        loading: isLoading
    };
};
exports.useFilter = useFilter;
